import {
    KR,
    TW,
    SG,
    MY,
    JP,
    VN,
    SA,
    AE
} from 'country-flag-icons/react/3x2';

const countries = [
    {
        code: "ALL",
        label: "All"
    },
    {
        code: "KR",
        label: "Korea",
        icon: KR
    },
    {
        code: "TW",
        label: "Taiwan",
        icon: TW
    },
    {
        code: "SG",
        label: "Singapore",
        icon: SG
    },
    {
        code: "MY",
        label: "Malaysia",
        icon: MY
    },
    {
        code: "JP",
        label: "Japan",
        icon: JP
    },
    {
        code: "VN",
        label: "Vietnam",
        icon: VN
    },
    {
        code: "SA",
        label: "Saudi Arabia",
        icon: SA
    },
    {
        code: "AE",
        label: "United Arab Emirates",
        icon: AE
    }
];

export default countries;